<!--
 * @Descripttion: 找回密码
 * @FilePath: /mall-wap-vue/src/views/login/forgot/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-10 14:58:31
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-25 11:04:44
-->
<template>
  <div class="forgot">
    <nav-bar @back="back" />
    <page-title title="找回密码" />
    <div class="login_con">
      <van-form ref="login" @submit="onSubmit">
        <!-- 手机号 -->
        <phone-field v-model="phone" @prefixChange="prefixChange" />
        <!-- 验证码 -->
        <code-field
          v-model="verifyCode"
          :phone="checkPhone"
          @senderCode="senderCode"
        />
        <div class="actions">
          <!-- 登录按钮 -->
          <van-button
            block
            type="info"
            native-type="submit"
            class="login_submit"
            :disabled="disabledBtn"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { verifyPhone } from "@/utils";

const NavBar = () => import("./components/NavBar");
const PageTitle = () => import("../components/PageTitle");
const PhoneField = () => import("../components/PhoneField");
const CodeField = () => import("../components/CodeField");

export default {
  components: {
    NavBar,
    PageTitle,
    PhoneField,
    CodeField
  },
  data() {
    return {
      prefix: "+86",
      phone: "",
      verifyCode: ""
    };
  },
  computed: {
    disabledBtn() {
      if (
        verifyPhone(this.prefix, this.phone) &&
        this.verifyCode.length === 6
      ) {
        return false;
      }
      return true;
    },
    checkPhone() {
      return verifyPhone(this.prefix, this.phone);
    }
  },
  methods: {
    back() {
      this.$router.go("-1");
    },
    prefixChange(value) {
      this.prefix = value;
    },
    onSubmit(values) {
      const { phone, verifyCode } = values;
      const areaCode = this.prefix.replace("+", "");
      this.$store
        .dispatch("login/checkVerifyCode", {
          params: {
            phone,
            code: verifyCode,
            kind: "ChangePwd",
            areaCode
          }
        })
        .then(() => {
          this.$router.push(
            `/forgot/reset?phone=${phone}&code=${verifyCode}&areaCode=${areaCode}`
          );
        })
        .catch(() => {});
    },
    // 发送验证码
    senderCode(callback) {
      const data = {
        phone: this.phone,
        kind: "ChangePwd",
        areaCode: this.prefix.replace("+", "")
      };
      this.$store
        .dispatch("login/sendSms", {
          params: data
        })
        .then(() => {
          this.$toast("验证码已发送到您的手机");
          callback();
          // this.$router.push({
          //   path: this.redirect || "/",
          //   query: this.otherQuery
          // });
        })
        .catch(err => {
          this.errorMsg = err.message;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.forgot {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .login_con {
    margin: 72px 38px;
  }

  .actions {
    margin-top: 38px;

    .login_submit {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border: none;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
    }
  }
}
</style>
